import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { LuHotel } from "react-icons/lu";
import { TbBedFilled } from "react-icons/tb";
import { HiUsers } from "react-icons/hi";
import { MdModeOfTravel } from "react-icons/md";
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { IoNewspaper } from "react-icons/io5";
import { IoIosSettings } from "react-icons/io";
import { IoWalletOutline } from "react-icons/io5";
import config from '../../../config';
import { FaUser, FaKey, FaWallet } from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";
import { useSidebar } from '../../../context/SidebarContext';
import { HiMenuAlt2 } from "react-icons/hi";

export default function Sidebar({ children }) {
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const location = useLocation();
    const [isAgencyUser, setAgencyUser] = useState(localStorage.getItem('is_agency_user'));
    const [isHotelUser, setHotelUser] = useState(localStorage.getItem('is_hotel_user'));
    const { isSidebarOpen, toggleSidebar } = useSidebar();

    const handleLogout = async () => {
        if (userData && userData.token) {
            try {
                await axios.post(`${config.API_BASE_URL_V1}auth/logout`, {}, {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                    },
                });
                localStorage.clear();
                localStorage.removeItem('user_data');
                window.location.href = '/login';
            } catch (error) {
                console.error('Logout error:', error.response?.data || error.message);
            }
        } else {
            window.location.href = '/login';
        }
    };

return (
<div className="row">
    <div className={`${isSidebarOpen ? 'col-xl-3 col-lg-4' : 'col-xl-1 col-lg-1'} theiaStickySidebar`}
         style={{
             transition: 'all 0.3s ease',
         }}>
        <div className="card user-sidebar agent-sidebar mb-lg-0 mb-4">
            <button 
                className="sidebar-toggle-btn" 
                onClick={toggleSidebar}
                style={{
                    position: 'absolute',
                    right: '-20px',
                    top: '20px',
                    zIndex: 1000,
                    background: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                }}
            >
                <HiMenuAlt2 size={24} />
            </button>

            {isSidebarOpen && (
                <div className="card-header user-sidebar-header bg-gray-transparent text-center">
                    <div className="agent-profile d-inline-flex">
                        <img src={userData?.user?.profile_photo != null ? userData?.user?.profile_photo : '/assets/img/user.jpg'} alt="image" style={{ objectFit:'cover' }} className="img-fluid rounded-circle" />
                    </div>
                    <h6 className="fs-16 mb-1"> {userData?.user?.name} {userData?.user?.surname} </h6>
                    <p className="fs-14 mb-1"> {userData?.user?.email} </p>
                    <p className="fs-14 mb-1">Agency Code: <span style={{ fontWeight:'bold' }}>{userData?.user?.agency_code}</span> </p>

                    {userData?.representive_user && (
                        <div className="representative-user mt-3 p-3" style={{ backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: '8px' }}>
                            <h6 className="fs-14 mb-3" style={{ color: '#666', borderBottom: '1px solid #ddd', paddingBottom: '8px' }}>
                                Account Manager
                            </h6>
                            <div className="user-details">
                                <p className="fs-14 mb-2">
                                     {userData?.representive_user?.name} {userData?.representive_user?.surname}
                                </p>
                                <p className="fs-14 mb-2">
                                     {userData?.representive_user?.email}
                                </p>
                                <p className="fs-14 mb-2">
                                     {userData?.representive_user?.phone || 'N/A'}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            )}

            <div className="card-body user-sidebar-body">
                <ul>
                    <li style={{ borderBottom:'solid', borderColor:'lightgray' }}>
                        <a 
                        href="/dashboard"
                        className={`d-flex align-items-center ${location.pathname === '/dashboard' ? 'active' : ''}`}
                        >
                            <TbLayoutDashboardFilled /> {isSidebarOpen && "Dashboard"}
                        </a>
                    </li>
                    { isAgencyUser && <>
                    <li>
                        <a href="/dashboard-bookings" className={`d-flex align-items-center ${location.pathname === '/dashboard-bookings' ? 'active' : ''}`}>
                        <IoNewspaper /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Bookings</p>}
                        </a>
                    </li>
                    </> }
                    { isAgencyUser && <>
                    <li >
                        <a href="/dashboard-users" className={`d-flex align-items-center ${location.pathname === '/dashboard-users' ? 'active' : ''}`}>
                        <HiUsers /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Users</p>}
                        </a>
                    </li>
                    </> }
                    { userData.user.parentId == null && <>
                    <li >
                        <a href="/dashboard-sub-agency" className={`d-flex align-items-center ${location.pathname === '/dashboard-sub-agency' ? 'active' : ''}`}>
                        <HiUsers /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Sub Agencies</p>}
                        </a>
                    </li>
                    </> }
                    { isAgencyUser && <>
                    <li>
                        <a href="/dashboard-credit" className={`d-flex align-items-center ${location.pathname === '/dashboard-credit' ? 'active' : ''}`}>
                        <FaWallet /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Credit / Credit Card</p>}
                        </a>
                    </li>
                    </> }
                    { isAgencyUser && <>
                    <li>
                        <a href="/dashboard-settings" className={`d-flex align-items-center ${location.pathname === '/dashboard-settings' ? 'active' : ''}`}>
                        <IoSettingsSharp /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Company Settings</p>}
                        </a>
                    </li>
                    </> }
                    { isAgencyUser && <>
                    <li>
                        <a href="/dashboard-profile" className={`d-flex align-items-center ${location.pathname === '/dashboard-profile' ? 'active' : ''}`}>
                        <FaUser /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Profile Management</p>}
                        </a>
                    </li>
                    </> }
                    { isAgencyUser && userData.user.isOwner == false && <>
                    <li>
                        <a href="/dashboard-representative-user" className={`d-flex align-items-center ${location.pathname === '/dashboard-representative-user' ? 'active' : ''}`}>
                        <FaUser /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Representative User</p>}
                        </a>
                    </li>
                    </> }
                    { isAgencyUser && <>
                    <li>
                        <a href="/dashboard-change-password" className={`d-flex align-items-center ${location.pathname === '/dashboard-change-password' ? 'active' : ''}`}>
                        <FaKey /> {isSidebarOpen && <p style={{ marginLeft:'5px' }}>Change Password</p>}
                        </a>
                    </li>
                    </> }
                    <li className="logout-link">
                        <a onClick={() => handleLogout()} className="d-flex align-items-center pb-0">
                            <i className="isax isax-logout-15"></i> {isSidebarOpen && "Logout"}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div className={`${isSidebarOpen ? 'col-xl-9 col-lg-8' : 'col-xl-11 col-lg-11'}`}
         style={{
             transition: 'all 0.3s ease',
         }}>
        {children}
    </div>
</div>
)
}
